import React from 'react'
import { Link } from '@paypalcorp/pp-react'
import FlowModal from 'components/modal/FlowModal'
import MainPage from 'components/layout/MainPage'
import EnrollmentMainPageLayout from 'components/layout/EnrollmentMainPageLayout'
import ModalPageLayout from 'components/common/ModalPageLayout'
import { isNewFlowModal, isOldFlowModal, isFlowIntentForEnrollment, isEnrollmentRoute } from 'utils/flow'
import { isMainView, getPayPalUrl, serverData } from 'utils/server-data'

/**
 * Get layout element name and props  based on the layout type
 * if it's a main layout, v1 or v2 modal layout.
 */
export const getLayoutElementDetails = () => {
  let LayoutElement = React.Fragment
  let layoutElementProps = {}

  // Override for GB enrollment flows only - check both query params AND route path
  const isGBEnrollmentFlow = serverData?.locality?.country === 'GB' && (isFlowIntentForEnrollment() || isEnrollmentRoute()) // eslint-disable-line i18n-scan/no-country-dependency -- GB-specific layout override for enrollment flows
  
  if (isGBEnrollmentFlow) {
    LayoutElement = EnrollmentMainPageLayout
    layoutElementProps = { showContentPage: true }
  } else if (isMainView()) {
    // Main layout
    LayoutElement = MainPage
    layoutElementProps = { showContentPage: true }
  } else if (isNewFlowModal()) {
    // v2 modal layout
    LayoutElement = FlowModal
  } else if (isOldFlowModal()) {
    // v1 modal layout
    LayoutElement = ModalPageLayout
  }

  return {
    LayoutElement,
    layoutElementProps,
  }
}

/**
 * Returs true if content value is localized, worldready will return the
 * content key if it's not localized, e.g. static.addMoney.header.
 */
export const isContentAvailable = (content) => {
  return !/^\w+\.\w+(.\w+)*$/.test(content) //NOSONAR
}

export const generateLink = (
  { href = '', onClick = () => {}, target = '', ...restOptions },
  text,
) => (
  <Link href={href} target={target} onClick={onClick} {...restOptions}>
    {text}
  </Link>
)

export const generatePayPalLink = (
  { path = '', onClick = () => {}, target = '', ...restOptions },
  text,
) => {
  const country = serverData.locality?.country?.toLowerCase()
  return generateLink(
    { href: getPayPalUrl(`${country}${path}`), onClick, target, ...restOptions },
    text,
  )
}
